import React from "react";
import { BrowserRouter, Route, Routes as ReactRoute } from "react-router-dom";
import Dashboard from "../dashboard/Dashboard";
import Layout from "../dashboard/Layout";
import ButtonsPage from "../Components/Elements/Buttons/ButtonsPage";
import ButtonGroupPage from "../Components/Elements/ButtonGroup/ButtonGroupPage";
import IconButtonPage from "../Components/Elements/IconButton/IconButtonPage";
import TextFieldPage from "../Components/Elements/TextField/TextFieldPage";
import TextareaPage from "../Components/Elements/Textarea/TextareaPage";
import SelectPage from "../Components/Elements/Select/SelectPage";
import ChipPage from "../Components/Elements/Chip/ChipPage";
import RadioPage from "../Components/Elements/Radio/RadioPage";
import SwitchPage from "../Components/Elements/Switch/SwitchPage";
import MenuPage from "../Components/Elements/Menu/MenuPage";
import BreadcrumbPage from "../Components/Elements/Breadcrumb/BreadcrumbPage";
import BadgePage from "../Components/Elements/Badge/BadgePage";
import TooltipPage from "../Components/Elements/Tooltip/TooltipPage";
import CheckboxPage from "../Components/Elements/Checkbox/CheckboxPage";
import AvatarPage from "../Components/Elements/Avatar/AvatarPage";
import ListPage from "../Components/Elements/List/ListPage";
import PaginationPage from "../Components/Elements/Pagination/PaginationPage";
import RatingPage from "../Components/Elements/Rating/RatingPage";
import TabsPage from "../Components/Elements/Tabs/TabsPage";
import IconPage from "../Components/Icons/IconPage";
import StepperPage from "../Components/Elements/Stepper/StepperPage";
import TypographyPage from "../Components/Elements/Typography/TypographyPage";
import AccordionPage from "../Components/Elements/Accordion/AccordionPage";
import ToggleButtonPage from "../Components/Elements/ToggleButton/ToggleButtonPage";
import ModalPage from "../Components/Elements/Modal/ModalPage";
import DrawerPage from "../Components/Elements/Drawer/DrawerPage";
import AlertPage from "../Components/Elements/Alert/AlertPage";
import DatePickerPage from "../Components/Elements/DatePicker/DatePickerPage";
import TimePickerPage from "../Components/Elements/TimePicker/TimePickerPage";
import TextEditorPage from "../Components/Elements/TextEditor/TextEditorPage";
import CardPage from "../Components/Elements/Card/CardPage";
import TablePage from "../Components/Elements/Table/TablePage";
import SnackbarPage from "../Components/Elements/Snackbar/SnackbarPage";
import FileUploadPage from "../Components/Elements/FileUpload/FileUploadPage";
import ColorPalettePage from "../Components/Elements/ColorPalette/ColorPalettePage";
import SkeletonPage from "../Components/Elements/Skeleton/SkeletonPage";

const Routes = () => {
  return (
    <BrowserRouter>
      <Layout>
        <ReactRoute>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/buttons" element={<ButtonsPage />} />
          <Route path="/iconbutton" element={<IconButtonPage />} />
          <Route path="/buttongroup" element={<ButtonGroupPage />} />
          <Route path="/textfield" element={<TextFieldPage />} />
          <Route path="/textarea" element={<TextareaPage />} />
          <Route path="/select" element={<SelectPage />} />
          <Route path="/switch" element={<SwitchPage />} />
          <Route path="/chip" element={<ChipPage />} />
          <Route path="/radio" element={<RadioPage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/breadcrumb" element={<BreadcrumbPage />} />
          <Route path="/badge" element={<BadgePage />} />
          <Route path="/tooltip" element={<TooltipPage />} />
          <Route path="/checkbox" element={<CheckboxPage />} />
          <Route path="/list" element={<ListPage />} />
          <Route path="/pagination" element={<PaginationPage />} />
          <Route path="/avatar" element={<AvatarPage />} />
          <Route path="/rating" element={<RatingPage />} />
          <Route path="/tabs" element={<TabsPage />} />
          <Route path="/icons" element={<IconPage />} />
          <Route path="/stepper" element={<StepperPage />} />
          <Route path="/typography" element={<TypographyPage />} />
          <Route path="/accordion" element={<AccordionPage />} />
          <Route path="/toggleButton" element={<ToggleButtonPage />} />
          <Route path="/modal" element={<ModalPage />} />
          <Route path="/drawer" element={<DrawerPage />} />
          <Route path="/alert" element={<AlertPage />} />
          <Route path="/date-picker" element={<DatePickerPage />} />
          <Route path="/time-picker" element={<TimePickerPage />} />
          <Route path="/table" element={<TablePage />} />
          <Route path="/text-editor" element={<TextEditorPage />} />
          <Route path="/card" element={<CardPage />} />
          <Route path="/snackbar" element={<SnackbarPage />} />
          <Route path="/fileUpload" element={<FileUploadPage />} />
          <Route path="/colors" element={<ColorPalettePage />} />
          <Route path="/skeleton" element={<SkeletonPage />} />
        </ReactRoute>
      </Layout>
    </BrowserRouter>
  );
};

export default Routes;
